<template>
  <div>
    <h2>stores</h2>
    {{ all_stores }}
    <h2>business types</h2>
    {{ all_business_types }}
    <h2>Available modules</h2>
    {{ availableModules }}
    <h2>Brands by filters</h2>
    <h2>brands by type</h2>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Example',
  mounted() {
    this.$store.commit('SET_SELECTED_GOORDER_TYPE', 'Popular Brand')
    this.$store.commit('SET_SELECTED_DELIVERY_OPTION', 'CRM')
    this.$store.commit('SET_SELECTED_KITCHEN_TYPE', '')
    this.$store.commit('SET_SELECTED_RADIUS', 2)
    this.$store.commit('SET_SELECTED_PRICE_RANGE', 100)
  },
  computed: {
    ...mapGetters([
      'all_stores',
      'all_business_types',
      'availableModules',
    ]),
  },
}
</script>
